import dom from "../../../../dist/jsx-render/dom";
import { ICustomerServive, CustomButtonHandler } from "../../../Frame/CustomerService/ICustomerService";
import { DynamicController } from "../../../Controls/Dynamic/DynamicController";
import { BaseControl } from "../../../Controls/Dynamic/BaseControl";
import { MultiCategoryControl } from "../../../Controls/Dynamic/MultiCategoryControl";
import { DynamicSymbolsPopup } from "../Gebaeudeplan/DynamicSymbolsPopup";
import { BuildingplanPins } from "../Gebaeudeplan/BuildingplanPins";
import { app } from "../../../Frame/App";
import { MeasureEdit } from "../../../Pages/Measure/MeasureEdit";
import { IFreigabe } from "../Gebaeudeplan/IFreigabe";
import { LinkMeasuresControl } from "../../../Controls/Dynamic/LinkMeasuresControl";
import { TextControl } from "../../../Controls/Dynamic/TextControl";
import { CategoryControl } from "../../../Controls/Dynamic/CategoryControl";
import { DocumentsControl } from "../../../Controls/Dynamic/DocumentsControl";
import { IDocumentInfo } from "../../../Model/IDocumentInfo";
import { FixedDialog } from "../../../Controls/FixedDialog";

//**Customer specific implementation for Kuraray*/
interface INumberDictionary {
    [index: number]: number;
}

class CategoryControlChild {
    parent: number;
    child: CategoryControl
}

export class KurarayCustomerService implements ICustomerServive {

    public hasCustomButton = true;
    private measureBuildingplanPins: BuildingplanPins;
    private streetPvbValues: INumberDictionary;
    private streetCategories: CategoryControlChild[];

    constructor() {
    }

    public isDisabledControl = (dynamicController: DynamicController, control: BaseControl, internalName: string, measureId: number): boolean => {
        return (internalName == "CopyLink" && measureId == 0);
    }
   
    public getDataFromSelectedMeasure: CustomButtonHandler = (event: Event, internalName: string, measureId: number, parentId: number, dynamicController: DynamicController) => {
        if (measureId == 0) {
            new FixedDialog().showOk(Resources.Massnahme.kuraraySaveWarning);
        } else {
            let sourceMeasure = dynamicController.getControlByInternalName("CopyLink") as LinkMeasuresControl;
            if (sourceMeasure) {
                let linkedMeasures = sourceMeasure.getListModelValue();
                if (linkedMeasures && linkedMeasures.length != 0) {
                    var selectedMeasureId = linkedMeasures[0].id;

                    let fieldName = ["categoryByInternalName:ControlElement",
                        "textByInternalName:ControlElementDecriptionText",
                        "categoryByInternalName:ControlElementDecription",
                        "categoryByInternalName:Medium",
                        "categoryByInternalName:Floor",
                        "multiCategoryByInternalName:LOTO_Materials",
                        "textByInternalName:PositionNumber_NEW"];

                    $.ajax({
                        url: app.resolveUrl(`~/api/measure/getMeasureValues/${selectedMeasureId}`),
                        method: "POST",
                        contentType: "application/json",
                        data: JSON.stringify(fieldName),
                        success: (response) => {
                            let fieldControlElement = dynamicController.getControlByInternalName('ControlElement') as CategoryControl;
                            let fieldControlElementDecriptionText = dynamicController.getControlByInternalName('ControlElementDecriptionText') as TextControl;
                            let fieldControlElementDecription = dynamicController.getControlByInternalName('ControlElementDecription') as CategoryControl;
                            let fieldMedium = dynamicController.getControlByInternalName('Medium') as CategoryControl;
                            let fieldFloor = dynamicController.getControlByInternalName('Floor') as CategoryControl;
                            let fieldLOTO_Materials = dynamicController.getControlByInternalName('LOTO_Materials') as MultiCategoryControl;
                            let fieldPositionNumber_NEW = dynamicController.getControlByInternalName('PositionNumber_NEW') as TextControl;
                            let fieldPicture = dynamicController.getControlByInternalName('Picture') as DocumentsControl;

                            if (fieldControlElement && response['ControlElement'] != undefined) {
                                fieldControlElement.setSelection(response['ControlElement']);
                            }

                            if (fieldControlElementDecriptionText && response['ControlElementDecriptionText'] != undefined) {
                                fieldControlElementDecriptionText.setValue(response['ControlElementDecriptionText']);
                            }

                            if (fieldControlElementDecription && response['ControlElementDecription'] != undefined) {
                                fieldControlElementDecription.setSelection(response['ControlElementDecription']);
                            }

                            if (fieldMedium && response['Medium'] != undefined) {
                                fieldMedium.setSelection(response['Medium']);
                            }
                           
                            if (fieldFloor && response['Floor'] != undefined) {
                                fieldFloor.setSelection(response['Floor']);
                            }
                            
                            if (fieldLOTO_Materials && response['LOTO_Materials'] != undefined) {
                                let values = response['LOTO_Materials'] as string;
                                if (values) {
                                    let valueList = values.substring(1, values.length - 1).split('@,@');
                                    if (valueList && valueList.length != 0) {
                                        let numberList: number[] = [];
                                        for (let val of valueList) {
                                            numberList.push(+val);
                                        }
                                        fieldLOTO_Materials.setValueById(numberList);
                                    }
                                }
                            }

                            if (fieldPositionNumber_NEW && response['PositionNumber_NEW'] != undefined) {
                                fieldPositionNumber_NEW.setValue(response['PositionNumber_NEW']);
                            }

                            if (fieldPicture) {
                                $.ajax({
                                    url: app.resolveUrl(`~/api/kuraray/copyDocuments/${selectedMeasureId}/${measureId}/Picture`),
                                    method: "POST",
                                    contentType: "application/json",
                                    success: (response) => {
                                        if (response && response.documentInfo) {
                                            for (let info of response.documentInfo as IDocumentInfo[]) {
                                                fieldPicture.attach(info);
                                            }
                                        }
                                    },
                                    error: (err) => {
                                        console.log(err);
                                    }
                                });
                            }
                           
                        },
                        error: (err) => {
                            window.alert(err);
                            console.log(err);
                        }
                    });
                }
                else {
                    new FixedDialog().showOk(Resources.Massnahme.kurarayNoLinkedMeasureWarning);
                }
            }
        }
    }

    public onChangeCategory = (dynamicController: DynamicController, internalName: string, categoryId: number, categoryContentId: number) => {
        if (this.streetCategories && this.streetCategories.length != 0 && this.streetPvbValues) {
            for (let cat of this.streetCategories) {
                if (cat.parent == categoryId) {
                    let pvbVal = this.streetPvbValues[cat.child.categoryId]
                    if (pvbVal) {
                        cat.child.setSelection(pvbVal);
                    }
                }
            }
           
        }
        
    }


    //**Customer specific action for Gebaeudestruktur custom button*/
    public showBuildingplanPopup: CustomButtonHandler = (event: Event, internalName: string, measureId: number, parentId: number, dynamicController: DynamicController) => {
        if (measureId || measureId == 0) {
            let pvaValues = (event.target as HTMLElement).getAttribute('buildingplan-pva-values');
            let selectedValues: number[];
            for (let key in dynamicController.controls) {
                let item = dynamicController.controls[key] as BaseControl;
                if (item.internalName == 'Gebaeudestruktur') {
                    selectedValues = (item as MultiCategoryControl).getSelectedAndPartiallySelectedIds();
                    break;
                }
            }

            <DynamicSymbolsPopup
                buildingplanValues={pvaValues}
                selectedValues={selectedValues}
                measureId={measureId}
            /> as DynamicSymbolsPopup;
        }
    }

    //** Save client data implemetation for Kuraray */
    public onSaveClientData = (clientData: any) => {
        let dynamicPins = clientData as IFreigabe[];
        this.measureBuildingplanPins.updatePins(dynamicPins);
    }

    //**Get client data implementation for Kuraray*/
    public getClientData = (): any => {
        return this.measureBuildingplanPins;
    }

    //**After save measure implementation for Kuraray*/
    public onAfterSave = (measureId: number, templateInternalName: string, measureEdit: MeasureEdit, callback: any) => {
        if (templateInternalName != "KleineFreigabe" && templateInternalName != "GrosseFreigabe") {
            if (callback) {
                callback();
            }
        }

        if (this.measureBuildingplanPins.getIsChangedByUser()) {
            let url = app.resolveUrl(`~/api/kuraraygebaeudeplan/savePinsForMeasure/${measureId.toString()}`);
            var formData = new FormData();
            formData.append("pins", JSON.stringify(this.measureBuildingplanPins.getResultPins()));
            $.ajax({
                url: url,
                type: "POST",
                dataType: 'json',
                processData: false,
                contentType: false,
                data: formData,
                success: () => {
                    if (callback) {
                        callback();
                    }
                },
                error: (err) => {
                    app.addError(err.responseText);

                    // If the save is not possible, we still need to execute the callback.
                    if (callback) {
                        callback();
                    }
                },
            });
        }
        else {
            if (callback) {
                callback();
            }
        }
    }

    //**Open measure specific actions for Kuraray*/
    public onOpenMeasure = (measureId: string, templateInternalName: string, measureEdit: MeasureEdit, initMeasure: boolean) => {
        if (templateInternalName != "KleineFreigabe" && templateInternalName != "GrosseFreigabe") return;

        if (initMeasure && measureId) {
            this.measureBuildingplanPins = new BuildingplanPins(+measureId);
            let selectedValues: number[];
            for (let key in measureEdit.controls.controls) {
                let item = measureEdit.controls.controls[key] as BaseControl;
                if (item.internalName == 'Gebaeudestruktur') {
                    selectedValues = (item as MultiCategoryControl).getSelectedAndPartiallySelectedIds();
                    break;
                }
            }
            let url = app.resolveUrl(`~/api/kuraraygebaeudeplan/getFreigabenForMeasure/${measureId}`);
            var formData = new FormData();
            formData.append("data", JSON.stringify(selectedValues));
            $.ajax({
                url: url,
                type: "POST",
                dataType: 'json',
                processData: false,
                contentType: false,
                data: formData,
                success: (items: IFreigabe[]) => {
                    this.measureBuildingplanPins.setupPins(items);
                },
                error: (err) => {
                    app.addError(err.responseText);
                },
            });
        }
    }

    //**Change multi category control handler implementation for Kuraray*/
    public onChangeMultiCategoryControl = (dynamicController: DynamicController, control: MultiCategoryControl, internalName: string, measureId: number) => {
        if (control.internalName != 'Gebaeudestruktur') return;

        let selectedValues = control.getSelectedAndPartiallySelectedIds();
        this.measureBuildingplanPins.updateBuildingplans(selectedValues);

        let topLevelNames = control.getSelectedTopLevelNodes();
        if (topLevelNames && topLevelNames.length > 0) {
            let pva = 0;
            topLevelNames.forEach(s => {
                if (s.businessModel.nameAll.valueDe.startsWith('PVA')) {
                    pva = s.businessModel.id;
                }
            });
            if (pva !== 0) {
                let buildingplans = this.getSelectedChildIds(control, pva);
                this.measureBuildingplanPins.addGeneralPins(buildingplans);
            }
        } else {
            let secondLevelNames = control.getSelectedSecondLevelNodes();
            if (secondLevelNames && secondLevelNames.length > 0) {
                let buildingList: number[] = [];
                secondLevelNames.forEach(s => {
                    if (s.parent.businessModel.nameAll.valueDe.startsWith('PVA')) {
                        buildingList.push(s.businessModel.id);
                    }
                });
                if (buildingList.length !== 0) {
                    for (let building of buildingList) {
                        let buildingplans = this.getSelectedChildIds(control, building);
                        this.measureBuildingplanPins.addGeneralPins(buildingplans);
                    }
                }
            }
        }
    }

    //**Empty multi category control check for Kuraray */
    public isEmptyMultiCategoryControl = (dynamicController: DynamicController, control: MultiCategoryControl, internalName: string, measureId: number): boolean => {
        if (internalName == "Gebaeudestruktur") {
            let selectedValues = control.getSelectedAndPartiallySelectedTopLevelNames();
            if (selectedValues && selectedValues.length > 0) {
                let isPvaSelected = false;
                selectedValues.forEach(s => {
                    if (s.startsWith('PVA')) {
                        isPvaSelected = true;
                    }
                });
                if (isPvaSelected) {
                    return (this.measureBuildingplanPins && this.measureBuildingplanPins.isEmpty())
                }
            }
        }
        return false;
    }

    //**Get the selected multicatergory child content*/
    private getSelectedChildIds = (control: MultiCategoryControl, id: number): number[] => {
        let selectedModels = control.getSelectedAndPartiallySelectedModels();
        if (selectedModels) {
            let selectedParents = selectedModels.filter(s => { return s.businessModel?.id && s.businessModel.parentValueId == id }).map(m => m.businessModel.id as number);
            let selectedBuildingplans = selectedParents;
            if (selectedParents) {
                selectedParents.forEach((parent) => {
                    let selectedChildren = selectedModels.filter(s => { return s.businessModel?.id && s.businessModel.parentValueId == parent }).map(m => m.businessModel.id as number);
                    if (selectedChildren) {
                        selectedBuildingplans.push(...selectedChildren);
                    }
                });
            }
            return selectedBuildingplans;
        }
        return [];
    }

    //**Check if there is no pin set on the measure*/
    public isEmpty = (): boolean => {
        return this.measureBuildingplanPins.isEmpty();
    }
}